import { Component, Input, ContentChild, AfterContentInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AccordionTitleBarComponent } from '../accordion-title-bar/accordion-title-bar.component';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate, group, state } from '@angular/animations';

let nextId = 0;

@Component({
  selector: 'vm-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('accordionItemContentAnimation', [
      state('isOpen', style({ height: '*' })),
      state('isClosed', style({ height: 0 })),
      transition('isOpen <=> isClosed', group([animate('200ms 0.2ms ease-in-out')])),
    ]),
  ],
})
export class AccordionItemComponent implements AfterContentInit, OnDestroy {
  @Input() isActive = false;

  public state: string = this.isActive ? 'isOpen' : 'isClosed';
  @ContentChild(AccordionTitleBarComponent, { static: false })
  accordionTitleBar: AccordionTitleBarComponent;

  id = `${nextId++}`;
  slideStatus;

  private isActiveSubscription: Subscription;

  ngAfterContentInit() {
    this.toggleItemState(this.isActive);

    if (this.isActive) {
      this.toggleItemState(this.isActive);
    }

    this.isActiveSubscription = this.accordionTitleBar.toggleActive.subscribe((isActive) => {
      this.toggleItemState(isActive);
    });
  }

  private toggleItemState(isActive: boolean) {
    this.isActive = isActive;
    this.accordionTitleBar.isActive = isActive;
    this.state = this.isActive ? 'isOpen' : 'isClosed';
  }

  ngOnDestroy() {
    if (this.isActiveSubscription) {
      this.isActiveSubscription.unsubscribe();
    }
  }
}
